export default {"src":"/_next/static/media/close-green.0fe8cd5d.svg","height":16,"width":16};